import { Injectable } from '@angular/core';
import { DispatcherModule } from '../dispatcher.module';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../state.model';
import { AuthActions } from './auth-actions';

@Injectable({
  providedIn: DispatcherModule,
})
export class AuthDispatcher {
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }
  /**
  * @method setAvailabletype sets the user type
  * @param type type of user
  **/
  setAvailabletype(type: Array<string>) {
    this.ngRedux.dispatch(AuthActions.setAvailabletype(type));
  }
  /**
  * @method setDealerDetails Store the user credentials
  * @param dealer code
  * @param email User email
  * @param Name User prefered name
  * @return void
  **/
  setUserDetails(user: object) {
    const userType: Array<string> = !!user['availableRoles'] ? user['availableRoles'] : [];
    this.ngRedux.dispatch(AuthActions.setAvailabletype(userType));
    this.ngRedux.dispatch(AuthActions.setUserDetails(user));
  }

  /**
  * @method setGuid Store the user GUID
  * @param guid User GUID
  * @return void
  **/
  setGuid(guid: string) {
    this.ngRedux.dispatch(AuthActions.setGuid(guid));
  }

  /**
  * @method setObjectId Store the user objectId
  * @param objectId User objectId
  * @return void
  **/
  setObjectId(objectId: string) {
    this.ngRedux.dispatch(AuthActions.setObjectId(objectId));
  }
  /**
  * @method setLogin Store the user login
  * @param isLoggedIn boolean whether login
  * @return void
  **/
  setLogin(isLoggedIn: boolean) {
    this.ngRedux.dispatch(AuthActions.setLogin(isLoggedIn));
  }
  /**
  * @method setToken Store the token
  * @param token User token
  * @return void
  **/
  setToken(token: string) {
    this.ngRedux.dispatch(AuthActions.setToken(token));

  }
  /**
  * @method set21mmToken Store the 21 mm token
  * @param token User token
  * @return void
  **/
  set21mmToken(token: string) {
    this.ngRedux.dispatch(AuthActions.set21mmToken(token));
  }
  /**
  * @method Logout logout
  * @return void
  **/
  logout() {
    this.ngRedux.dispatch(AuthActions.logout());
  }
  /**
  * setCMSAuthorized sets if user can create CMS tickets or not
  * @param authorized value true or false
  **/
  setCMSAuthorized(authorized: boolean): void {
    this.ngRedux.dispatch(AuthActions.setCMSAuthorized(authorized));
  }
}
